module.exports = __webpack_public_path__ + "img/foreplay-api-logo.c72d6ace.png";